module.exports = __webpack_public_path__ + "media/mokpho.10caba26.mp3";